import { IsString, IsBoolean, IsNotEmpty, IsOptional, IsArray, IsEmail } from "class-validator";
import { Transform } from "class-transformer";

import { IEventMessage } from "./event-message.interface";

export class EventMessageDto implements IEventMessage {
  @IsNotEmpty()
  @IsString()
  content: string;

  @IsOptional()
  @IsBoolean()
  // NOTE: in case of multipart/form-data content type
  @Transform(({ obj: { attach_registration_summary } }) => {
     if (typeof attach_registration_summary === 'string') return attach_registration_summary === 'true';
     return attach_registration_summary;
  })
  attach_registration_summary?: boolean;

  @IsOptional()
  attachments?: File[];

  @IsOptional()
  @IsArray()
  @IsEmail({}, { each: true })
  custom_emails?: string[];

  @IsOptional()
  @IsString()
  custom_subject?: string;

  @IsOptional()
  @IsBoolean()
  @Transform(({ obj: { is_test_sending } }) => {
    if (typeof is_test_sending === 'string') return is_test_sending === 'true';
    return is_test_sending;
  })
  is_test_sending?: boolean;

  @IsOptional()
  @IsBoolean()
  @Transform(({ obj: { only_qualified } }) => {
    if (typeof only_qualified === 'string') return only_qualified === 'true';
    return only_qualified;
  })
  only_qualified?: boolean;

  @IsOptional()
  @IsString()
  test_target_user_id?: string;
}
